<template>
  <div>
    <div class="row localContainer"  v-if="selected_account_id && selected_project_id">
      <div v-if="view !== 'task' && view !== 'project' && !filter" class="col-1">
        <div class="avatar">
          <img v-if="(members.find(user => user._id === selected_account_id, 1) || {}).picture_url" :src="(members.find(user => user._id === selected_account_id, 1) || {}).picture_url" style="transition: 1s filter ease-out;" alt="..." class="avatar-img rounded-circle shadow">
          <span v-else class="avatar-title mr-2 rounded-circle unselectable shadow">{{((members.find(user => user._id === selected_account_id, 1) || {}).first_name || '').slice(0, 1)+((members.find(user => user._id === selected_account_id, 1) || {}).last_name || '').slice(0, 1)}}</span>
        </div>
      </div>
      <div :class="[view === 'project' || filter ? 'col-12': 'col-8']">
        <select v-if="view === 'task'" :ref="'personSelectTask'+unique_id" :id="'personSelectTask'+unique_id" v-model="selected_task.assignee"  class="form-control form-control-sm mb-2" data-toggle="select">
          <option v-if="(exclude_emika ? person._id !== 'emika' : true) && !(person._id in exclude_list)" :selected="selected_task.assignee === person._id" v-for="person in (show_all_projects ? members.filter(user => projects.find(project => project._id === selected_task.project_id, 1).members.indexOf(user._id) > -1) : members.filter(user => !(exclude_list.indexOf(user._id) >= 0) && projects.find(project => project._id === selected_project_id, 1).members.indexOf(user._id) >= 0))"
                   :data-avatar-src="person.picture_url" :value="person._id" :data-position="person.job_title">
            {{person.first_name}} {{person.last_name}}
          </option>
        </select>
        <select v-else-if="!filter" :ref="'personSelect'+unique_id" :id="'personSelect'+unique_id" v-model="selected_account_id"  class="form-control form-control-sm mb-2" data-toggle="select">
          <option v-if="(exclude_emika ? person._id !== 'emika' : true) && !(exclude_list.indexOf(person._id) > -1)" :selected="selected_account_id === person._id" v-for="person in (show_all_projects ? members : members.filter(user => !(exclude_list.indexOf(user._id) >= 0)  && projects.find(project => project._id === selected_project_id, 1).members.indexOf(user._id) >= 0))"
                  :data-avatar-src="person.picture_url" :value="person._id" :data-position="person.job_title">
            {{person.first_name}} {{person.last_name}}
          </option>
        </select>
        <small class="text-muted ml-2 ">
          <span v-if="view === 'task' ? selected_task.assignee === 'emika' : selected_account_id === 'emika'">
            Unassigned
          </span>
          <span v-else>
            {{(members.find(user => view === 'task' ? user._id === selected_task.assignee : user._id === selected_account_id, 1) || {}).job_title}}
          </span>
          <router-link v-if="!filter" :to="'/members/'+(members.find(user => view === 'task' ? user._id === selected_task.assignee : user._id === selected_account_id, 1) || {})._id" class="btn btn-xs float-right btn-link text-muted">{{ $t("elements.person_select.open_profile") }}</router-link>
        </small>
      </div>

      <div v-if="view === 'task'" class="col-4 ">
        <div class="avatar avatar">
          <img v-if="(members.find(user => user._id === selected_task.assignee, 1) || {}).picture_url" :src="(members.find(user => user._id === selected_task.assignee, 1) || {}).picture_url" style="transition: 1s filter ease-out;" alt="..." class="avatar-img rounded-circle shadow">
          <span v-else class="avatar-title mr-2 rounded-circle font-weight-bold unselectable shadow">{{((members.find(user => user._id === selected_task.assignee, 1) || {}).first_name || '').slice(0, 1)+((members.find(user => user._id === selected_task.assignee, 1) || {}).last_name || '').slice(0, 1)}}</span>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="d-flex align-items-center">
        <span class=" m-auto spinner-grow spinner-grow-sm text-primary"></span>
      </div>
    </div>
  </div>

</template>

<script>
    import { mapGetters } from 'vuex';
    export default {
        name: "PersonSelect",
        props: {
            filter: {
                default: false
            },
            isCalendar: {
                default: false
            },
            show_all_projects: {
                default: true
            },
            exclude_emika: {
                default: true
            },
            exclude_list: {
                default: function () {
                  return []
                }
            },
            hide_mode: {
                default: false,
            },
            view: {
                default: 'select'
            },
            projectSettings: {
              default: false
            },
            projectAssignee: {
              default: ''
            }
        },
        data: function () {
            return {
                unique_id: 'no',
                local_selected_account_id: 'all_people',
            }

        },
        computed: {
            ...mapGetters([
                'account',
                'projects',
                'selected_account_id',
                'selected_project_id',
                'selected_task',
                'members',
                'calendar_filter',
                'tasks_filter'
            ]),
        },
        watch: {
            members: function (new_val, old_val) {
                this.enableSelect()
            },
            selected_account_id: function (new_val, old_val) {
                if (this.view !== 'task') {
                    this.enableSelect()
                }
            },
            selected_project_id: function (new_val, old_val) {
                if (this.view !== 'task') {
                    this.enableSelect()
                }
            },
            selected_task: function () {
                if (this.view === 'task') {
                    this.enableSelect()
                }
            }
        },
        methods: {
            enableSelect() {
                let self = this;
                function init_select($this) {
                    var options = {
                        dropdownParent: $this.closest('.modal').length ? $this.closest('.modal') : $(document.body),
                        minimumResultsForSearch: $this.data('minimum-results-for-search'),
                        templateResult: formatAvatar
                    };
                  $this
                      .select2(options)
                      .on('change', function () {
                          if (self.view === 'task') {
                              self.selected_task.assignee = this.value
                          } else {
                              if (!self.filter){
                                self.projectSettings ? self.$emit('selectUser', this.value) : self.$store.commit('setSelectedAccountId',  this.value);
                              } else {
                                self.$store.commit(self.isCalendar ? 'setCalendarFilter' : 'setTaskFilter', {'slug': 'by_user', 'value': this.value});
                              }
                          }

                      });
                }

                function formatAvatar(avatar) {
                    if ( !avatar.id ) {
                        return avatar.text;
                    }
                    var $option = $(avatar.element);
                    var optionAvatar = $option.data('avatar-src');
                    var optionPosition = $option.data('position');
                    var output;
                    if (!optionPosition) {
                        optionPosition = '';
                    } else if (optionPosition.length > 23) {
                        optionPosition = optionPosition.slice(0, 20)+'...'
                    }
                    if ( optionAvatar ) {
                        output = $('<span class="avatar avatar-xs mr-3"><img class="avatar-img rounded-circle" src="' + optionAvatar + '" alt="..."></span><span>' + avatar.text + '</span><span class="text-muted small float-right">'+optionPosition +'</span>');
                    } else {
                        output = $('<span class="avatar avatar-xs mr-3"><img class="avatar-img rounded-circle" src="' + self.$api().defaults.baseURL+'/common/files/default_profile_picture' + '" alt="..."></span><span>' + avatar.text + '</span><span class="text-muted small float-right">'+optionPosition +'</span>');
                    }
                    return output;
                }
                if (self.view === 'task') {
                    setTimeout(() => init_select( $(document.getElementById('personSelectTask'+self.unique_id))), 10);
                    // setTimeout(() => init_select( $(document.getElementById('personSelectTask'))), 600);
                } else {
                    setTimeout(() => init_select( $(document.getElementById('personSelect'+self.unique_id))), 10);
                    // setTimeout(() => init_select( $(document.getElementById('personSelect'))), 600);
                }
            }
        },
        created(){
            this.unique_id = Math.random().toString();
            this.enableSelect();
            this.local_selected_account_id = this.isCalendar ? this.calendar_filter.by_user : this.tasks_filter.by_user;
            // console.log((this.show_all_projects ? this.members : (this.task_options.by_project[this.selected_project_id] || {}).assignee))
            // this.$store.dispatch('fetchTaskTemplateAndOptions');
            // window.onload = function() {
            //     this.enableSelect()
            // }.bind(this);
        },

  }
</script>

<style scoped>

  .show {
    opacity: 1;
    -webkit-transition: opacity 0.3s ease-in-out;
    -moz-transition: opacity 0.3s ease-in-out;
    -ms-transition: opacity 0.3s ease-in-out;
    -o-transition: opacity 0.3s ease-in-out;
    transition: opacity 0.3s ease-in-out;
  }

  .hide {
    opacity: 0.4;
    -webkit-transition: opacity 1s ease-in-out;
    -moz-transition: opacity 1s ease-in-out;
    -ms-transition: opacity 1s ease-in-out;
    -o-transition: opacity 1s ease-in-out;
    transition: opacity 1s ease-in-out;
  }

</style>

